import { render, staticRenderFns } from "./cardCustom.vue?vue&type=template&id=3d41a998&"
import script from "./cardCustom.vue?vue&type=script&lang=js&"
export * from "./cardCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports